import React, { useEffect, useState } from 'react'
import { AdvancedChart } from 'react-tradingview-embed'

// import TradingOrderBook from './TradingOrderBook';
// import RecentTrades from './RecentTrades';
import MarketTrade from './MarketTrade'
// import Orders from './Orders';
import { Icon } from '../../../components/UI'

const TradingSell = () => {
  const [showLogo, setShowLogo] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowLogo(true)
    }, 1500)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <div className="w-full flex flex-col items-start">
      <div className="relative w-full h-[600px]">
        <AdvancedChart
          widgetProps={{
            theme: 'light',
            symbol: 'BINANCE:BTCUSDT',
            allow_symbol_change: true,
            toolbar_bg: '#fff',
            height: 600,
            width: '100%',
          }}
        />

        {showLogo && (
          <Icon
            name="logo"
            className="absolute bottom-[82px] left-[62px] z-[1] w-[50px] h-[50px] bg-white"
          />
        )}
      </div>

      <div className="mt-0 w-full flex items-start justify-between gap-x-[15px]">
        {/*<div className="flex-1">*/}
        {/*  <TradingOrderBook />*/}
        {/*</div>*/}

        <div className="w-full">
          <MarketTrade />
        </div>

        {/*<div className="flex-1">*/}
        {/*  <RecentTrades />*/}
        {/*</div>*/}
      </div>

      {/*<Orders />*/}
    </div>
  )
}

export default TradingSell
